export default __webpack_public_path__ + "static/media/1697.1c2c7291.png";